import { Action, createReducer, on } from '@ngrx/store';
import { IProofBusinessFicaDocs } from '../models/business-proof-fica-doc.model';
import * as actions from '../actions';

export const proofBusinessFicaDocsFeatureKey = 'proofBusinessFicaDocs';

export interface ProofBusinessFicaDocsState {
  loadGetProofBusinessFicaDocs: string;
  loadGetProofBusinessFicaDocsSuccess: IProofBusinessFicaDocs[];
  loadGetProofBusinessFicaDocsFailure: Error | any;
  loaded: boolean;
}

export const initialState: ProofBusinessFicaDocsState = {
  loadGetProofBusinessFicaDocs: undefined,
  loadGetProofBusinessFicaDocsSuccess: undefined,
  loadGetProofBusinessFicaDocsFailure: undefined,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(actions.loadGetProofBusinessFicaDocs, (state, action) => ({
    ...state,
    loadGetProofBusinessFicaDocs: action.businessId
  })),
  on(actions.loadGetProofBusinessFicaDocsSuccess, (state, action) => ({
    ...state,
    loadGetProofBusinessFicaDocsSuccess: action.response,
    loaded: true
  })),
  on(actions.loadGetProofBusinessFicaDocsFailure, (state, action) => ({
    ...state,
    loadGetProofBusinessFicaDocsFailure: action.error,
    loaded: true
  })),
  on(actions.clearGetProofBusinessFicaDocs, (state, action) => ({
    ...state,
    loadGetProofBusinessFicaDocsSuccess: undefined,
    loaded: false
  }))
);

export const getProofBusinessFicaDocs = (state: ProofBusinessFicaDocsState) => state.loadGetProofBusinessFicaDocsSuccess;
export const getProofBusinessFicaDocsIsLoaded = (state: ProofBusinessFicaDocsState) => state.loaded;
export const getProofBusinessFicaDocsFailure = (state: ProofBusinessFicaDocsState) => state.loadGetProofBusinessFicaDocsFailure;
